import { Action } from 'redux-actions';

export interface DebugState {
  lastCall: Action<any>;
  olderCall?: Action<any>;
}

const initialState: DebugState = {
  lastCall: { type: '', payload: undefined },
};

export default (
  state: DebugState = initialState,
  action: Action<any>,
): DebugState => ({
  lastCall: action,
  olderCall: state?.lastCall,
});
